/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'email-sync-outline': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M3 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h10.5a6.5 6.5 0 01-.5-2H3V8l8 5 8-5v3a6.5 6.5 0 01.5 0 6.5 6.5 0 011.5.18V6c0-1.1-.9-2-2-2H3m0 2h16l-8 5-8-5m16 6l-2.25 2.25L19 16.5V15a2.5 2.5 0 012.5 2.5c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21 0-2.21-1.79-4-4-4V12m-3.33 3.29c-.42.63-.67 1.39-.67 2.21 0 2.21 1.79 4 4 4V23l2.25-2.25L19 18.5V20a2.5 2.5 0 01-2.5-2.5c0-.4.09-.78.26-1.12l-1.09-1.09z"/>'
  }
})
